import PropTypes from 'prop-types';
import { FeatureList, FeatureItem, FeatureName, RolesText } from './styles';

const FeatureRoleList = ({ features }) => {
  if (!features || features.length === 0) {
    return null;
  }

  return (
    <FeatureList>
      {features.map((feature, featureIndex) => {
        const featureName = feature.name || feature.alias || feature.tag;
        const roles = feature.roles || [];
        const rolesText = roles.map(role => role.name || role.alias).join(', ');

        return (
          <FeatureItem key={feature.id || `feature-${featureIndex}`}>
            <FeatureName>{featureName}</FeatureName>
            <RolesText>{rolesText || '-'}</RolesText>
          </FeatureItem>
        );
      })}
    </FeatureList>
  );
};

FeatureRoleList.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      tag: PropTypes.string,
      alias: PropTypes.string,
      name: PropTypes.string,
      roles: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          tag: PropTypes.string,
          alias: PropTypes.string,
          name: PropTypes.string,
        })
      ),
    })
  ),
};

FeatureRoleList.defaultProps = {
  features: [],
};

export default FeatureRoleList;
